/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { FireCommandCameraConfig } from '../models/fire-command-camera-config';
import { PagedResultOfFireCommandCameraConfig } from '../models/paged-result-of-fire-command-camera-config';
import { AzureIotHubCameraConfig } from '../models/azure-iot-hub-camera-config';
import { MqttCameraConfig } from '../models/mqtt-camera-config';
import { CheckLicenseRequest } from '../models/check-license-request';
@Injectable({
  providedIn: 'root',
})
class FireCommandService extends __BaseService {
  static readonly FireCommandGetCameraConfigPath = '/api/FireCommand/{id}';
  static readonly FireCommandGetCameraConfigsPath = '/api/FireCommand';
  static readonly FireCommandCreateAzureIotHubCameraConfigPath = '/api/FireCommand/AzureIotHub';
  static readonly FireCommandCreateMqttCameraConfigPath = '/api/FireCommand/Mqtt';
  static readonly FireCommandUpdateAzureIotHubCameraConfigPath = '/api/FireCommand/AzureIotHub/{id}';
  static readonly FireCommandUpdateMqttCameraConfigPath = '/api/FireCommand/Mqtt/{id}';
  static readonly FireCommandFinishCameraConfigAccessPath = '/api/FireCommand/{id}/Finish';
  static readonly FireCommandUnfreezePath = '/api/FireCommand/Unfreeze';
  static readonly FireCommandCheckLicensePath = '/api/FireCommand/CheckLicense';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param id undefined
   */
  FireCommandGetCameraConfigResponse(id: number): __Observable<__StrictHttpResponse<FireCommandCameraConfig>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/FireCommand/${encodeURIComponent(String(id))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<FireCommandCameraConfig>;
      })
    );
  }
  /**
   * @param id undefined
   */
  FireCommandGetCameraConfig(id: number): __Observable<FireCommandCameraConfig> {
    return this.FireCommandGetCameraConfigResponse(id).pipe(
      __map(_r => _r.body as FireCommandCameraConfig)
    );
  }

  /**
   * @param params The `FireCommandService.FireCommandGetCameraConfigsParams` containing the following parameters:
   *
   * - `pageSize`:
   *
   * - `page`:
   *
   * - `connectionMode`:
   */
  FireCommandGetCameraConfigsResponse(params: FireCommandService.FireCommandGetCameraConfigsParams): __Observable<__StrictHttpResponse<PagedResultOfFireCommandCameraConfig>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.pageSize != null) __params = __params.set('pageSize', params.pageSize.toString());
    if (params.page != null) __params = __params.set('page', params.page.toString());
    if (params.connectionMode != null) __params = __params.set('connectionMode', params.connectionMode.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/FireCommand`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<PagedResultOfFireCommandCameraConfig>;
      })
    );
  }
  /**
   * @param params The `FireCommandService.FireCommandGetCameraConfigsParams` containing the following parameters:
   *
   * - `pageSize`:
   *
   * - `page`:
   *
   * - `connectionMode`:
   */
  FireCommandGetCameraConfigs(params: FireCommandService.FireCommandGetCameraConfigsParams): __Observable<PagedResultOfFireCommandCameraConfig> {
    return this.FireCommandGetCameraConfigsResponse(params).pipe(
      __map(_r => _r.body as PagedResultOfFireCommandCameraConfig)
    );
  }

  /**
   * @param params The `FireCommandService.FireCommandCreateAzureIotHubCameraConfigParams` containing the following parameters:
   *
   * - `Provisioned`:
   *
   * - `Id`:
   *
   * - `FirstAccessed`:
   *
   * - `FireforesightCameraId`:
   *
   * - `ConnectionMode`:
   *
   * - `CameraSerial`:
   *
   * - `AzureHubSasTokenExpiry`:
   *
   * - `AzureHubSasToken`:
   *
   * - `AzureHubHostName`:
   *
   * - `AzureHubDeviceId`:
   *
   * - `AzureBlobUrl`:
   *
   * - `AzureBlobSasToken`:
   *
   * - `AzureBlobSasExpiry`:
   *
   * - `AccessKey`:
   *
   * - `AccessEnded`:
   *
   * - `AccessCreated`:
   */
  FireCommandCreateAzureIotHubCameraConfigResponse(params: FireCommandService.FireCommandCreateAzureIotHubCameraConfigParams): __Observable<__StrictHttpResponse<AzureIotHubCameraConfig>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.Provisioned != null) __params = __params.set('Provisioned', params.Provisioned.toString());
    if (params.Id != null) __params = __params.set('Id', params.Id.toString());
    if (params.FirstAccessed != null) __params = __params.set('FirstAccessed', params.FirstAccessed.toString());
    if (params.FireforesightCameraId != null) __params = __params.set('FireforesightCameraId', params.FireforesightCameraId.toString());
    if (params.ConnectionMode != null) __params = __params.set('ConnectionMode', params.ConnectionMode.toString());
    if (params.CameraSerial != null) __params = __params.set('CameraSerial', params.CameraSerial.toString());
    if (params.AzureHubSasTokenExpiry != null) __params = __params.set('AzureHubSasTokenExpiry', params.AzureHubSasTokenExpiry.toString());
    if (params.AzureHubSasToken != null) __params = __params.set('AzureHubSasToken', params.AzureHubSasToken.toString());
    if (params.AzureHubHostName != null) __params = __params.set('AzureHubHostName', params.AzureHubHostName.toString());
    if (params.AzureHubDeviceId != null) __params = __params.set('AzureHubDeviceId', params.AzureHubDeviceId.toString());
    if (params.AzureBlobUrl != null) __params = __params.set('AzureBlobUrl', params.AzureBlobUrl.toString());
    if (params.AzureBlobSasToken != null) __params = __params.set('AzureBlobSasToken', params.AzureBlobSasToken.toString());
    if (params.AzureBlobSasExpiry != null) __params = __params.set('AzureBlobSasExpiry', params.AzureBlobSasExpiry.toString());
    if (params.AccessKey != null) __params = __params.set('AccessKey', params.AccessKey.toString());
    if (params.AccessEnded != null) __params = __params.set('AccessEnded', params.AccessEnded.toString());
    if (params.AccessCreated != null) __params = __params.set('AccessCreated', params.AccessCreated.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/FireCommand/AzureIotHub`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<AzureIotHubCameraConfig>;
      })
    );
  }
  /**
   * @param params The `FireCommandService.FireCommandCreateAzureIotHubCameraConfigParams` containing the following parameters:
   *
   * - `Provisioned`:
   *
   * - `Id`:
   *
   * - `FirstAccessed`:
   *
   * - `FireforesightCameraId`:
   *
   * - `ConnectionMode`:
   *
   * - `CameraSerial`:
   *
   * - `AzureHubSasTokenExpiry`:
   *
   * - `AzureHubSasToken`:
   *
   * - `AzureHubHostName`:
   *
   * - `AzureHubDeviceId`:
   *
   * - `AzureBlobUrl`:
   *
   * - `AzureBlobSasToken`:
   *
   * - `AzureBlobSasExpiry`:
   *
   * - `AccessKey`:
   *
   * - `AccessEnded`:
   *
   * - `AccessCreated`:
   */
  FireCommandCreateAzureIotHubCameraConfig(params: FireCommandService.FireCommandCreateAzureIotHubCameraConfigParams): __Observable<AzureIotHubCameraConfig> {
    return this.FireCommandCreateAzureIotHubCameraConfigResponse(params).pipe(
      __map(_r => _r.body as AzureIotHubCameraConfig)
    );
  }

  /**
   * @param params The `FireCommandService.FireCommandCreateMqttCameraConfigParams` containing the following parameters:
   *
   * - `UseTls`:
   *
   * - `Provisioned`:
   *
   * - `MqttUsername`:
   *
   * - `MqttTopicTelemetry`:
   *
   * - `MqttTopicImage`:
   *
   * - `MqttTopicCommand`:
   *
   * - `MqttPassword`:
   *
   * - `MqttClientId`:
   *
   * - `MqttBrokerUrl`:
   *
   * - `MqttBrokerPort`:
   *
   * - `Id`:
   *
   * - `FirstAccessed`:
   *
   * - `FireforesightCameraId`:
   *
   * - `ConnectionMode`:
   *
   * - `CameraSerial`:
   *
   * - `AzureBlobUrl`:
   *
   * - `AzureBlobSasToken`:
   *
   * - `AzureBlobSasExpiry`:
   *
   * - `AccessKey`:
   *
   * - `AccessEnded`:
   *
   * - `AccessCreated`:
   */
  FireCommandCreateMqttCameraConfigResponse(params: FireCommandService.FireCommandCreateMqttCameraConfigParams): __Observable<__StrictHttpResponse<MqttCameraConfig>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.UseTls != null) __params = __params.set('UseTls', params.UseTls.toString());
    if (params.Provisioned != null) __params = __params.set('Provisioned', params.Provisioned.toString());
    if (params.MqttUsername != null) __params = __params.set('MqttUsername', params.MqttUsername.toString());
    if (params.MqttTopicTelemetry != null) __params = __params.set('MqttTopicTelemetry', params.MqttTopicTelemetry.toString());
    if (params.MqttTopicImage != null) __params = __params.set('MqttTopicImage', params.MqttTopicImage.toString());
    if (params.MqttTopicCommand != null) __params = __params.set('MqttTopicCommand', params.MqttTopicCommand.toString());
    if (params.MqttPassword != null) __params = __params.set('MqttPassword', params.MqttPassword.toString());
    if (params.MqttClientId != null) __params = __params.set('MqttClientId', params.MqttClientId.toString());
    if (params.MqttBrokerUrl != null) __params = __params.set('MqttBrokerUrl', params.MqttBrokerUrl.toString());
    if (params.MqttBrokerPort != null) __params = __params.set('MqttBrokerPort', params.MqttBrokerPort.toString());
    if (params.Id != null) __params = __params.set('Id', params.Id.toString());
    if (params.FirstAccessed != null) __params = __params.set('FirstAccessed', params.FirstAccessed.toString());
    if (params.FireforesightCameraId != null) __params = __params.set('FireforesightCameraId', params.FireforesightCameraId.toString());
    if (params.ConnectionMode != null) __params = __params.set('ConnectionMode', params.ConnectionMode.toString());
    if (params.CameraSerial != null) __params = __params.set('CameraSerial', params.CameraSerial.toString());
    if (params.AzureBlobUrl != null) __params = __params.set('AzureBlobUrl', params.AzureBlobUrl.toString());
    if (params.AzureBlobSasToken != null) __params = __params.set('AzureBlobSasToken', params.AzureBlobSasToken.toString());
    if (params.AzureBlobSasExpiry != null) __params = __params.set('AzureBlobSasExpiry', params.AzureBlobSasExpiry.toString());
    if (params.AccessKey != null) __params = __params.set('AccessKey', params.AccessKey.toString());
    if (params.AccessEnded != null) __params = __params.set('AccessEnded', params.AccessEnded.toString());
    if (params.AccessCreated != null) __params = __params.set('AccessCreated', params.AccessCreated.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/FireCommand/Mqtt`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<MqttCameraConfig>;
      })
    );
  }
  /**
   * @param params The `FireCommandService.FireCommandCreateMqttCameraConfigParams` containing the following parameters:
   *
   * - `UseTls`:
   *
   * - `Provisioned`:
   *
   * - `MqttUsername`:
   *
   * - `MqttTopicTelemetry`:
   *
   * - `MqttTopicImage`:
   *
   * - `MqttTopicCommand`:
   *
   * - `MqttPassword`:
   *
   * - `MqttClientId`:
   *
   * - `MqttBrokerUrl`:
   *
   * - `MqttBrokerPort`:
   *
   * - `Id`:
   *
   * - `FirstAccessed`:
   *
   * - `FireforesightCameraId`:
   *
   * - `ConnectionMode`:
   *
   * - `CameraSerial`:
   *
   * - `AzureBlobUrl`:
   *
   * - `AzureBlobSasToken`:
   *
   * - `AzureBlobSasExpiry`:
   *
   * - `AccessKey`:
   *
   * - `AccessEnded`:
   *
   * - `AccessCreated`:
   */
  FireCommandCreateMqttCameraConfig(params: FireCommandService.FireCommandCreateMqttCameraConfigParams): __Observable<MqttCameraConfig> {
    return this.FireCommandCreateMqttCameraConfigResponse(params).pipe(
      __map(_r => _r.body as MqttCameraConfig)
    );
  }

  /**
   * @param params The `FireCommandService.FireCommandUpdateAzureIotHubCameraConfigParams` containing the following parameters:
   *
   * - `Id`:
   *
   * - `id`:
   *
   * - `Provisioned`:
   *
   * - `FirstAccessed`:
   *
   * - `FireforesightCameraId`:
   *
   * - `ConnectionMode`:
   *
   * - `CameraSerial`:
   *
   * - `AzureHubSasTokenExpiry`:
   *
   * - `AzureHubSasToken`:
   *
   * - `AzureHubHostName`:
   *
   * - `AzureHubDeviceId`:
   *
   * - `AzureBlobUrl`:
   *
   * - `AzureBlobSasToken`:
   *
   * - `AzureBlobSasExpiry`:
   *
   * - `AccessKey`:
   *
   * - `AccessEnded`:
   *
   * - `AccessCreated`:
   */
  FireCommandUpdateAzureIotHubCameraConfigResponse(params: FireCommandService.FireCommandUpdateAzureIotHubCameraConfigParams): __Observable<__StrictHttpResponse<AzureIotHubCameraConfig>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.id != null) __params = __params.set('id', params.id.toString());
    if (params.Provisioned != null) __params = __params.set('Provisioned', params.Provisioned.toString());
    if (params.FirstAccessed != null) __params = __params.set('FirstAccessed', params.FirstAccessed.toString());
    if (params.FireforesightCameraId != null) __params = __params.set('FireforesightCameraId', params.FireforesightCameraId.toString());
    if (params.ConnectionMode != null) __params = __params.set('ConnectionMode', params.ConnectionMode.toString());
    if (params.CameraSerial != null) __params = __params.set('CameraSerial', params.CameraSerial.toString());
    if (params.AzureHubSasTokenExpiry != null) __params = __params.set('AzureHubSasTokenExpiry', params.AzureHubSasTokenExpiry.toString());
    if (params.AzureHubSasToken != null) __params = __params.set('AzureHubSasToken', params.AzureHubSasToken.toString());
    if (params.AzureHubHostName != null) __params = __params.set('AzureHubHostName', params.AzureHubHostName.toString());
    if (params.AzureHubDeviceId != null) __params = __params.set('AzureHubDeviceId', params.AzureHubDeviceId.toString());
    if (params.AzureBlobUrl != null) __params = __params.set('AzureBlobUrl', params.AzureBlobUrl.toString());
    if (params.AzureBlobSasToken != null) __params = __params.set('AzureBlobSasToken', params.AzureBlobSasToken.toString());
    if (params.AzureBlobSasExpiry != null) __params = __params.set('AzureBlobSasExpiry', params.AzureBlobSasExpiry.toString());
    if (params.AccessKey != null) __params = __params.set('AccessKey', params.AccessKey.toString());
    if (params.AccessEnded != null) __params = __params.set('AccessEnded', params.AccessEnded.toString());
    if (params.AccessCreated != null) __params = __params.set('AccessCreated', params.AccessCreated.toString());
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/api/FireCommand/AzureIotHub/${encodeURIComponent(String(params.id))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<AzureIotHubCameraConfig>;
      })
    );
  }
  /**
   * @param params The `FireCommandService.FireCommandUpdateAzureIotHubCameraConfigParams` containing the following parameters:
   *
   * - `Id`:
   *
   * - `id`:
   *
   * - `Provisioned`:
   *
   * - `FirstAccessed`:
   *
   * - `FireforesightCameraId`:
   *
   * - `ConnectionMode`:
   *
   * - `CameraSerial`:
   *
   * - `AzureHubSasTokenExpiry`:
   *
   * - `AzureHubSasToken`:
   *
   * - `AzureHubHostName`:
   *
   * - `AzureHubDeviceId`:
   *
   * - `AzureBlobUrl`:
   *
   * - `AzureBlobSasToken`:
   *
   * - `AzureBlobSasExpiry`:
   *
   * - `AccessKey`:
   *
   * - `AccessEnded`:
   *
   * - `AccessCreated`:
   */
  FireCommandUpdateAzureIotHubCameraConfig(params: FireCommandService.FireCommandUpdateAzureIotHubCameraConfigParams): __Observable<AzureIotHubCameraConfig> {
    return this.FireCommandUpdateAzureIotHubCameraConfigResponse(params).pipe(
      __map(_r => _r.body as AzureIotHubCameraConfig)
    );
  }

  /**
   * @param params The `FireCommandService.FireCommandUpdateMqttCameraConfigParams` containing the following parameters:
   *
   * - `Id`:
   *
   * - `id`:
   *
   * - `UseTls`:
   *
   * - `Provisioned`:
   *
   * - `MqttUsername`:
   *
   * - `MqttTopicTelemetry`:
   *
   * - `MqttTopicImage`:
   *
   * - `MqttTopicCommand`:
   *
   * - `MqttPassword`:
   *
   * - `MqttClientId`:
   *
   * - `MqttBrokerUrl`:
   *
   * - `MqttBrokerPort`:
   *
   * - `FirstAccessed`:
   *
   * - `FireforesightCameraId`:
   *
   * - `ConnectionMode`:
   *
   * - `CameraSerial`:
   *
   * - `AzureBlobUrl`:
   *
   * - `AzureBlobSasToken`:
   *
   * - `AzureBlobSasExpiry`:
   *
   * - `AccessKey`:
   *
   * - `AccessEnded`:
   *
   * - `AccessCreated`:
   */
  FireCommandUpdateMqttCameraConfigResponse(params: FireCommandService.FireCommandUpdateMqttCameraConfigParams): __Observable<__StrictHttpResponse<MqttCameraConfig>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.id != null) __params = __params.set('id', params.id.toString());
    if (params.UseTls != null) __params = __params.set('UseTls', params.UseTls.toString());
    if (params.Provisioned != null) __params = __params.set('Provisioned', params.Provisioned.toString());
    if (params.MqttUsername != null) __params = __params.set('MqttUsername', params.MqttUsername.toString());
    if (params.MqttTopicTelemetry != null) __params = __params.set('MqttTopicTelemetry', params.MqttTopicTelemetry.toString());
    if (params.MqttTopicImage != null) __params = __params.set('MqttTopicImage', params.MqttTopicImage.toString());
    if (params.MqttTopicCommand != null) __params = __params.set('MqttTopicCommand', params.MqttTopicCommand.toString());
    if (params.MqttPassword != null) __params = __params.set('MqttPassword', params.MqttPassword.toString());
    if (params.MqttClientId != null) __params = __params.set('MqttClientId', params.MqttClientId.toString());
    if (params.MqttBrokerUrl != null) __params = __params.set('MqttBrokerUrl', params.MqttBrokerUrl.toString());
    if (params.MqttBrokerPort != null) __params = __params.set('MqttBrokerPort', params.MqttBrokerPort.toString());
    if (params.FirstAccessed != null) __params = __params.set('FirstAccessed', params.FirstAccessed.toString());
    if (params.FireforesightCameraId != null) __params = __params.set('FireforesightCameraId', params.FireforesightCameraId.toString());
    if (params.ConnectionMode != null) __params = __params.set('ConnectionMode', params.ConnectionMode.toString());
    if (params.CameraSerial != null) __params = __params.set('CameraSerial', params.CameraSerial.toString());
    if (params.AzureBlobUrl != null) __params = __params.set('AzureBlobUrl', params.AzureBlobUrl.toString());
    if (params.AzureBlobSasToken != null) __params = __params.set('AzureBlobSasToken', params.AzureBlobSasToken.toString());
    if (params.AzureBlobSasExpiry != null) __params = __params.set('AzureBlobSasExpiry', params.AzureBlobSasExpiry.toString());
    if (params.AccessKey != null) __params = __params.set('AccessKey', params.AccessKey.toString());
    if (params.AccessEnded != null) __params = __params.set('AccessEnded', params.AccessEnded.toString());
    if (params.AccessCreated != null) __params = __params.set('AccessCreated', params.AccessCreated.toString());
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/api/FireCommand/Mqtt/${encodeURIComponent(String(params.id))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<MqttCameraConfig>;
      })
    );
  }
  /**
   * @param params The `FireCommandService.FireCommandUpdateMqttCameraConfigParams` containing the following parameters:
   *
   * - `Id`:
   *
   * - `id`:
   *
   * - `UseTls`:
   *
   * - `Provisioned`:
   *
   * - `MqttUsername`:
   *
   * - `MqttTopicTelemetry`:
   *
   * - `MqttTopicImage`:
   *
   * - `MqttTopicCommand`:
   *
   * - `MqttPassword`:
   *
   * - `MqttClientId`:
   *
   * - `MqttBrokerUrl`:
   *
   * - `MqttBrokerPort`:
   *
   * - `FirstAccessed`:
   *
   * - `FireforesightCameraId`:
   *
   * - `ConnectionMode`:
   *
   * - `CameraSerial`:
   *
   * - `AzureBlobUrl`:
   *
   * - `AzureBlobSasToken`:
   *
   * - `AzureBlobSasExpiry`:
   *
   * - `AccessKey`:
   *
   * - `AccessEnded`:
   *
   * - `AccessCreated`:
   */
  FireCommandUpdateMqttCameraConfig(params: FireCommandService.FireCommandUpdateMqttCameraConfigParams): __Observable<MqttCameraConfig> {
    return this.FireCommandUpdateMqttCameraConfigResponse(params).pipe(
      __map(_r => _r.body as MqttCameraConfig)
    );
  }

  /**
   * @param id undefined
   */
  FireCommandFinishCameraConfigAccessResponse(id: number): __Observable<__StrictHttpResponse<FireCommandCameraConfig>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/FireCommand/${encodeURIComponent(String(id))}/Finish`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<FireCommandCameraConfig>;
      })
    );
  }
  /**
   * @param id undefined
   */
  FireCommandFinishCameraConfigAccess(id: number): __Observable<FireCommandCameraConfig> {
    return this.FireCommandFinishCameraConfigAccessResponse(id).pipe(
      __map(_r => _r.body as FireCommandCameraConfig)
    );
  }
  FireCommandUnfreezeResponse(): __Observable<__StrictHttpResponse<Array<FireCommandCameraConfig>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/FireCommand/Unfreeze`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<FireCommandCameraConfig>>;
      })
    );
  }  FireCommandUnfreeze(): __Observable<Array<FireCommandCameraConfig>> {
    return this.FireCommandUnfreezeResponse().pipe(
      __map(_r => _r.body as Array<FireCommandCameraConfig>)
    );
  }

  /**
   * @param request undefined
   */
  FireCommandCheckLicenseResponse(request: CheckLicenseRequest): __Observable<__StrictHttpResponse<FireCommandCameraConfig>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/FireCommand/CheckLicense`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<FireCommandCameraConfig>;
      })
    );
  }
  /**
   * @param request undefined
   */
  FireCommandCheckLicense(request: CheckLicenseRequest): __Observable<FireCommandCameraConfig> {
    return this.FireCommandCheckLicenseResponse(request).pipe(
      __map(_r => _r.body as FireCommandCameraConfig)
    );
  }
}

module FireCommandService {

  /**
   * Parameters for FireCommandGetCameraConfigs
   */
  export interface FireCommandGetCameraConfigsParams {
    pageSize?: number;
    page?: number;
    connectionMode?: null | 0 | 1;
  }

  /**
   * Parameters for FireCommandCreateAzureIotHubCameraConfig
   */
  export interface FireCommandCreateAzureIotHubCameraConfigParams {
    Provisioned?: null | string;
    Id?: number;
    FirstAccessed?: null | string;
    FireforesightCameraId?: number;
    ConnectionMode?: 0 | 1;
    CameraSerial?: null | string;
    AzureHubSasTokenExpiry?: null | string;
    AzureHubSasToken?: null | string;
    AzureHubHostName?: null | string;
    AzureHubDeviceId?: string;
    AzureBlobUrl?: null | string;
    AzureBlobSasToken?: null | string;
    AzureBlobSasExpiry?: null | string;
    AccessKey?: string;
    AccessEnded?: null | string;
    AccessCreated?: string;
  }

  /**
   * Parameters for FireCommandCreateMqttCameraConfig
   */
  export interface FireCommandCreateMqttCameraConfigParams {
    UseTls?: boolean;
    Provisioned?: null | string;
    MqttUsername?: null | string;
    MqttTopicTelemetry?: null | string;
    MqttTopicImage?: null | string;
    MqttTopicCommand?: null | string;
    MqttPassword?: null | string;
    MqttClientId?: string;
    MqttBrokerUrl?: null | string;
    MqttBrokerPort?: null | number;
    Id?: number;
    FirstAccessed?: null | string;
    FireforesightCameraId?: number;
    ConnectionMode?: 0 | 1;
    CameraSerial?: null | string;
    AzureBlobUrl?: null | string;
    AzureBlobSasToken?: null | string;
    AzureBlobSasExpiry?: null | string;
    AccessKey?: string;
    AccessEnded?: null | string;
    AccessCreated?: string;
  }

  /**
   * Parameters for FireCommandUpdateAzureIotHubCameraConfig
   */
  export interface FireCommandUpdateAzureIotHubCameraConfigParams {
    Id: number;
    id?: number;
    Provisioned?: null | string;
    FirstAccessed?: null | string;
    FireforesightCameraId?: number;
    ConnectionMode?: 0 | 1;
    CameraSerial?: null | string;
    AzureHubSasTokenExpiry?: null | string;
    AzureHubSasToken?: null | string;
    AzureHubHostName?: null | string;
    AzureHubDeviceId?: string;
    AzureBlobUrl?: null | string;
    AzureBlobSasToken?: null | string;
    AzureBlobSasExpiry?: null | string;
    AccessKey?: string;
    AccessEnded?: null | string;
    AccessCreated?: string;
  }

  /**
   * Parameters for FireCommandUpdateMqttCameraConfig
   */
  export interface FireCommandUpdateMqttCameraConfigParams {
    Id: number;
    id?: number;
    UseTls?: boolean;
    Provisioned?: null | string;
    MqttUsername?: null | string;
    MqttTopicTelemetry?: null | string;
    MqttTopicImage?: null | string;
    MqttTopicCommand?: null | string;
    MqttPassword?: null | string;
    MqttClientId?: string;
    MqttBrokerUrl?: null | string;
    MqttBrokerPort?: null | number;
    FirstAccessed?: null | string;
    FireforesightCameraId?: number;
    ConnectionMode?: 0 | 1;
    CameraSerial?: null | string;
    AzureBlobUrl?: null | string;
    AzureBlobSasToken?: null | string;
    AzureBlobSasExpiry?: null | string;
    AccessKey?: string;
    AccessEnded?: null | string;
    AccessCreated?: string;
  }
}

export { FireCommandService }
